import React, { useState } from 'react';

export default function HistoryView({ events }) {
  const [search, setSearch] = useState('');

  const completedEvents = events.filter((e) => e.assignment_status === 'completed');

  const filtered = completedEvents.filter((e) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      e.venue_name?.toLowerCase().includes(term) ||
      e.customer?.name?.toLowerCase().includes(term) ||
      e.event_date?.includes(term) ||
      e.booth_type?.toLowerCase().includes(term)
    );
  });

  const totalHoursWorked = completedEvents.reduce(
    (sum, e) => sum + parseFloat(e.actual_hours_worked || e.scheduled_hours || 0),
    0
  );

  return (
    <div>
      {/* Top Metrics Cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 16,
          marginBottom: 24,
        }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #101428 0%, #0d0f22 100%)',
            border: '1px solid rgba(39, 200, 90, 0.3)',
            borderRadius: 16,
            padding: '20px',
          }}
        >
          <div style={{ fontSize: 12, color: '#7c7c9c', textTransform: 'uppercase', fontWeight: 700 }}>
            Total Events Delivered
          </div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#27C85A', marginTop: 4 }}>
            {completedEvents.length}
          </div>
        </div>

        <div
          style={{
            background: 'linear-gradient(135deg, #101428 0%, #0d0f22 100%)',
            border: '1px solid rgba(159, 92, 255, 0.3)',
            borderRadius: 16,
            padding: '20px',
          }}
        >
          <div style={{ fontSize: 12, color: '#7c7c9c', textTransform: 'uppercase', fontWeight: 700 }}>
            Cumulative Hours Logged
          </div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#9F5CFF', marginTop: 4 }}>
            {totalHoursWorked.toFixed(1)} hrs
          </div>
        </div>

        <div
          style={{
            background: 'linear-gradient(135deg, #101428 0%, #0d0f22 100%)',
            border: '1px solid rgba(0, 210, 255, 0.3)',
            borderRadius: 16,
            padding: '20px',
          }}
        >
          <div style={{ fontSize: 12, color: '#7c7c9c', textTransform: 'uppercase', fontWeight: 700 }}>
            Average Hours / Event
          </div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#00D2FF', marginTop: 4 }}>
            {completedEvents.length > 0 ? (totalHoursWorked / completedEvents.length).toFixed(1) : 0} hrs
          </div>
        </div>
      </div>

      {/* Search Input */}
      <div style={{ marginBottom: 20 }}>
        <input
          type="text"
          placeholder="🔍 Search completed events by venue, client, or date…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: '100%',
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 12,
            padding: '12px 16px',
            color: '#fff',
            fontSize: 13,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* History List */}
      {filtered.length === 0 ? (
        <div
          style={{
            textAlign: 'center',
            padding: '40px',
            background: 'rgba(255,255,255,0.02)',
            borderRadius: 16,
            border: '1px dashed rgba(255,255,255,0.08)',
            color: '#7c7c9c',
          }}
        >
          No completed event records found.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {filtered.map((event) => (
            <div
              key={event.id}
              style={{
                background: 'linear-gradient(145deg, #101428 0%, #0d0f22 100%)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: 14,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 12,
              }}
            >
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span
                    style={{
                      fontFamily: 'monospace',
                      fontSize: 11,
                      color: '#a0a0b8',
                      background: 'rgba(255,255,255,0.05)',
                      padding: '2px 6px',
                      borderRadius: 4,
                    }}
                  >
                    #{event.id}
                  </span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>
                    📅 {event.event_date}
                  </span>
                  <span
                    style={{
                      background: 'rgba(39, 200, 90, 0.15)',
                      color: '#27C85A',
                      fontSize: 10,
                      fontWeight: 700,
                      padding: '2px 8px',
                      borderRadius: 10,
                      textTransform: 'uppercase',
                    }}
                  >
                    Completed
                  </span>
                </div>

                <div style={{ fontSize: 14, color: '#fff', fontWeight: 600, marginTop: 4 }}>
                  🏛️ {event.venue_name || 'Venue'}
                </div>
                <div style={{ fontSize: 12, color: '#7c7c9c', marginTop: 2 }}>
                  👤 {event.customer?.name} • 🎪 {event.booth_type}
                </div>

                {event.organizer_notes && (
                  <p style={{ margin: '6px 0 0', fontSize: 12, color: '#a0a0b8', fontStyle: 'italic' }}>
                    "{event.organizer_notes}"
                  </p>
                )}
              </div>

              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 15, fontWeight: 800, color: '#27C85A' }}>
                  {event.actual_hours_worked || event.scheduled_hours} hrs
                </div>
                <div style={{ fontSize: 11, color: '#7c7c9c' }}>Logged Work Time</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
